function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.559 41.72a5.092 5.092 0 0 1-3.625-8.686 5.095 5.095 0 0 1 3.598-1.501 5.1 5.1 0 0 1 0 10.187h.027zm0-9.21a4.15 4.15 0 0 0-4.07 4.069 4.07 4.07 0 1 0 4.138-4.07h-.068zM8.967 41.72a5.087 5.087 0 0 1-3.609-8.695 5.168 5.168 0 0 1 3.609-1.492 5.1 5.1 0 0 1 0 10.187zm0-9.21a4.15 4.15 0 0 0-4.07 4.069 4.07 4.07 0 1 0 4.137-4.07h-.067z",
  fill: "#E4ECFF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M9.107 38.629a2.01 2.01 0 1 1-.001-4.02 2.01 2.01 0 0 1 0 4.02z",
  stroke: "#E4ECFF"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M.04 36.796h.864c1 0 1.809-.81 1.809-1.809v-.335h1.438l.122-.298a5.181 5.181 0 0 1 4.64-3.093h.094a5.603 5.603 0 0 1 4.72 3.432l.136.299h3.73l.123-.313a5.547 5.547 0 0 1 4.788-3.445 5.168 5.168 0 0 1 4.992 3.323l.123.326H58v-.99H28.283a6.309 6.309 0 0 0-5.806-3.65 6.403 6.403 0 0 0-5.534 3.758h-2.456a6.403 6.403 0 0 0-5.426-3.73H8.94a6.2 6.2 0 0 0-5.426 3.391H1.736V35.1a.732.732 0 0 1-.732.733L.98 31.872a.49.49 0 0 0-.98.003v4.88c0 .022.018.04.04.04z",
  fill: "#E4ECFF"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M.5 32 7 28.5",
  stroke: "#E4ECFF",
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M43 27.965H6.988a.488.488 0 0 0 0 .977H43v-.977zM31.227 33.866h-1.736v-3.893h1.736v3.893zm-1.248-.489h.76v-2.916h-.76v2.916zM16.536 33.866H14.8v-3.893h1.736v3.893zm-1.248-.489h.76v-2.916h-.76v2.916z",
  fill: "#E4ECFF"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m23.632 34.767.188-.315-.188.315a2.01 2.01 0 1 1-2.067 3.449 2.01 2.01 0 0 1 2.067-3.45z",
  stroke: "#E4ECFF"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M64.107 41.72a5.092 5.092 0 0 1-4.724-7.03 5.094 5.094 0 0 1 4.697-3.158 5.1 5.1 0 0 1 0 10.188h.027zm0-9.211a4.15 4.15 0 0 0-4.07 4.07 4.07 4.07 0 1 0 4.138-4.07h-.068z",
  fill: "#E4ECFF"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M64.107 38.629a2.01 2.01 0 1 1-.001-4.02 2.01 2.01 0 0 1 0 4.02zM33 34.5V37h8l1.5 1m0 0h15c0-1.568.354-4.12 2-5.804M42.5 38v-8.5m0-1v1m17-11.5 12.491 3.904a5 5 0 0 1 3.509 4.772V34.22M59.5 18c-3-10-6.924-15.461-17-17v27.195M59.5 18v9m0 5.196c.978-1.001 2.413-1.696 4.5-1.696 3.45 0 5.116 1.708 5.887 3.72M59.5 32.196V27m10.387 7.22c.48 1.255.613 2.628.613 3.78h4a1 1 0 0 0 1-1v-2.78m-5.613 0H75.5M59.5 27c-.167.833-.8 2.5-2 2.5h-15M44.5 23H48M61 23.5h4M61 25.5h4",
  stroke: "#E4ECFF"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M42.5 7h3.325a4 4 0 0 1 2.163.635l5.024 3.23a4 4 0 0 0 2.163.635H57M54.661 14.5H46a1 1 0 0 0-1 1V19a1 1 0 0 0 1 1h3.06a1 1 0 0 1 .737.324l2.156 2.352a1 1 0 0 0 .737.324h3.118a1 1 0 0 0 .985-1.174l-1.147-6.5a1 1 0 0 0-.985-.826z",
  stroke: "#E4ECFF"
});

var SvgTractorDayCab = function SvgTractorDayCab(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 42,
    viewBox: "0 0 76 42",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTractorDayCab, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tractorDayCab.6ec4ea00.svg";
export { ForwardRef as ReactComponent };